<template>
    <v-dialog v-model="abrir" persistent max-width="70vw" scrollable>
        <v-container>
        <v-card max-height="600px" :loading="loading">
            <v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
            
            <v-card-text>
                <v-data-table fixed-header :items="clas" :headers="fields" :items-per-page="10">
                </v-data-table>
            </v-card-text>
            <v-divider>
            </v-divider>
            <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn small color="primary" @click.stop="fechar()">Fechar</v-btn>
            </v-card-actions>

        </v-card>
        </v-container>
    </v-dialog>
</template>

<script>
    
    //import Br from '@/config/barramento'
    import { baseApiUrl, showError } from "@/config/global"
    import axios from 'axios'

	export default{
        name: "HistoricoClas",
        props: ['abrir', 'iniciado'],

		data(){
			return {
                loading: false,
                cor: 'primary',
                clas: [],
				fields: [
                    {text: 'Clã', value: 'cla', align: 'center', divider: true},
					{text: 'Data', value: 'data', align: 'center', divider: true},
                ],
			}
		},

		methods:{

			buscaClas(id){
                
				const url = `${baseApiUrl}/perfil/buscaClas.php?iniciado=${id}`

				axios.post(url, this.iniciado)
				.then(res => {
					if(res.data.codigo == '01'){
                        this.clas = res.data.clas
					}else{
                        showError(res.data.mensagem)
                    }
                })
                
                this.loading = false
            },
            
            fechar(){
                this.$emit('fechar')
            },
            
		},

        watch:{
            abrir(val){
                if(val){
                    if(this.clas.length == 0){
                        this.buscaClas(this.iniciado)
                    }
                }
            }
        }
	}
</script>

<style scoped>


</style>